import { render } from "./TicketsRealizationPie.vue?vue&type=template&id=2bea0406"
import script from "./TicketsRealizationPie.vue?vue&type=script&lang=js"
export * from "./TicketsRealizationPie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__